<template>
    <div id="journeyplanner-app">
        <NavItems></NavItems>
        <div class="tab-content p-3">
            <JourneyPlanner></JourneyPlanner>
            <RealTime></RealTime>
        </div>
    </div>
</template>

<script>
    import NavItems from './components/NavItems.vue'
    import JourneyPlanner from './components/JourneyPlanner.vue'
    import RealTime from './components/RealTime.vue'
    export default {
        name: 'journeyplanner-app',
        components: {
            NavItems,
            JourneyPlanner,
            RealTime
        }
    }
</script>